export const getCurrentIsoWeek = () => {
  const now = new Date();
  const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
  const dayNum = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  return { week, year: date.getUTCFullYear() };
};

export const getRecentIsoWeekOptions = (count = 12) => {
  const { week: currentWeek, year: currentYear } = getCurrentIsoWeek();
  const options: { value: string; week: number; year: number }[] = [];
  for (let offset = 0; offset >= -(count - 1); offset -= 1) {
    let week = currentWeek + offset;
    let year = currentYear;
    while (week < 1) {
      year -= 1;
      week += 52;
    }
    options.push({ value: `${week}-${year}`, week, year });
  }
  return options;
};
